export const MAPS_SLICE_NAME = 'maps' as const;
